/** Pure production collision primitives. No world generation or object registry. */
export const PLAYER_RADIUS = 0.28;
export function resolveStaticCollider(x, z, collider) {
    if (collider.shape === "circle") {
        return resolveCircle(x, z, collider.x, collider.z, collider.radius + PLAYER_RADIUS, Math.cos(collider.fallbackAngle), Math.sin(collider.fallbackAngle));
    }
    const cosine = Math.cos(collider.yaw);
    const sine = Math.sin(collider.yaw);
    const offsetX = x - collider.x;
    const offsetZ = z - collider.z;
    const localX = offsetX * cosine - offsetZ * sine;
    const localZ = offsetX * sine + offsetZ * cosine;
    let resolvedX = localX;
    let resolvedZ = localZ;
    if (collider.shape === "capsule") {
        const axisX = Math.max(-collider.halfLength, Math.min(collider.halfLength, localX));
        [resolvedX, resolvedZ] = resolveCircle(localX, localZ, axisX, 0, collider.radius + PLAYER_RADIUS, 0, 1);
    }
    else {
        const closestX = Math.max(-collider.halfWidth, Math.min(collider.halfWidth, localX));
        const closestZ = Math.max(-collider.halfDepth, Math.min(collider.halfDepth, localZ));
        const differenceX = localX - closestX;
        const differenceZ = localZ - closestZ;
        const distanceSquared = differenceX * differenceX + differenceZ * differenceZ;
        if (distanceSquared > 0.00000001) {
            if (distanceSquared < PLAYER_RADIUS * PLAYER_RADIUS) {
                const distance = Math.sqrt(distanceSquared);
                resolvedX = closestX + (differenceX / distance) * PLAYER_RADIUS;
                resolvedZ = closestZ + (differenceZ / distance) * PLAYER_RADIUS;
            }
        }
        else {
            const escapeX = collider.halfWidth + PLAYER_RADIUS - Math.abs(localX);
            const escapeZ = collider.halfDepth + PLAYER_RADIUS - Math.abs(localZ);
            if (escapeX < escapeZ)
                resolvedX = (localX < 0 ? -1 : 1) * (collider.halfWidth + PLAYER_RADIUS);
            else
                resolvedZ = (localZ < 0 ? -1 : 1) * (collider.halfDepth + PLAYER_RADIUS);
        }
    }
    return [
        collider.x + resolvedX * cosine + resolvedZ * sine,
        collider.z - resolvedX * sine + resolvedZ * cosine,
    ];
}
function resolveCircle(x, z, centerX, centerZ, minimumDistance, fallbackX, fallbackZ) {
    const differenceX = x - centerX;
    const differenceZ = z - centerZ;
    const distanceSquared = differenceX * differenceX + differenceZ * differenceZ;
    if (distanceSquared >= minimumDistance * minimumDistance)
        return [x, z];
    const distance = Math.sqrt(distanceSquared);
    const directionX = distance > 0.0001 ? differenceX / distance : fallbackX;
    const directionZ = distance > 0.0001 ? differenceZ / distance : fallbackZ;
    return [centerX + directionX * minimumDistance, centerZ + directionZ * minimumDistance];
}
